import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tag, Button, Input, Popover, List, Space } from "antd";
import {
  PlusOutlined,
  CaretRightOutlined,
  SearchOutlined,
  ReloadOutlined
} from "@ant-design/icons";
import "./talentList.css";

import FilterLocation from "./filterComponents/filterLocation";
import FilterRating from "./filterComponents/filterRating";
import FilterAge from "./filterComponents/filterAge";
import FilterWeight from "./filterComponents/filterWeight";
import FilterGender from "./filterComponents/filterGender";
import FilterEthnicity from "./filterComponents/filterEthnicity";
import FilterEyeColor from "./filterComponents/filterEyeColor";
import FilterHairColor from "./filterComponents/filterHairColor";
import FilterHeight from "./filterComponents/filterHeight";
import FilterRole from "./filterComponents/filterRole";
import FilterSkill from "./filterComponents/filterSkill";

const { Search } = Input;

const SearchComponent = (props) => {
  const {
    eventRoles,
    skillCategorized,
    languageCategorized,
    isAddPersonToRole = false,
    isShortlisted=false
  } = props;

  const [searchText, setSearchText] = useState("");

  const {
    addFilter,
    removeFilter,
    clearAll,
    talentFilter,
    talentFilterTags,
  } = props.filterManager;


  // hydrate search field
  useEffect(() => {
    if (talentFilter?.search_field) {
      setSearchText(talentFilter.search_field);
    }
  }, []);

  const onSearch = (value) => {
    setSearchText(value);

    if (!value && talentFilterTags.length === 0) {
      props.filterManager.clearAll();
      return;
    }

    const base = { ...(talentFilter || {}) };

    if (value) base.search_field = value;
    else delete base.search_field;

    props.filterManager.addFilter("search", { base });
  };

  const filters = [
    {
      title: "Location (US Only)",
      component: (
        <FilterLocation
          talentFilter={talentFilter}
          talentData={props.talentData}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Rating",
      component: (
        <FilterRating
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Age",
      component: (
        <FilterAge
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Gender",
      component: (
        <FilterGender
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Ethnicity",
      component: (
        <FilterEthnicity
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Height",
      component: (
        <FilterHeight
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Weight",
      component: (
        <FilterWeight
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Eye color",
      component: (
        <FilterEyeColor
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Hair color",
      component: (
        <FilterHairColor
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Role(s)",
      component: (
        <FilterRole
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          eventRoles={eventRoles}
          onAddFilter={addFilter}
        />
      ),
    },
    {
      title: "Skill(s)",
      component: (
        <FilterSkill
          talentFilter={talentFilter}
          talentFilterTags={talentFilterTags}
          skillCategorized={skillCategorized}
          languageCategorized={languageCategorized}
          onAddFilter={addFilter}
        />
      ),
    },
  ];

  const filterMenu = (
    <List
      className="w-full"
      itemLayout="horizontal"
      dataSource={filters}
      renderItem={(item, index) => (
        <List.Item>
          <Popover
            placement="rightTop"
            content={item.component}
            arrow={false}
            trigger="click"
          >
            <List.Item.Meta title={<span>{item.title}</span>} />
            <div className="float-right">
              <CaretRightOutlined className="align-baseline text-[#D9D9D9] text-[11px]" />
            </div>
          </Popover>
        </List.Item>
      )}
    />
  );

  const onClearAllFilter = () => {
    setSearchText("");
    props.filterManager.clearAll();
  };

  return (
    <div
      className={`${
        isAddPersonToRole ? "pt-[10px]" : "pt-[23px]"
      } ${isShortlisted ? "w-[100%]" : "w-[97%]"} mx-auto search-section`}
    >
      <Search
        placeholder="Search by name, email, social handle, or phone number..."
        allowClear
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        onSearch={onSearch}
        style={{ width: 490, border: "1px solid #98A2B380", borderRadius: '6px', paddingRight: '0', background: '#F2F4F7' }}
        prefix={<SearchOutlined />}
      />

      {!isAddPersonToRole && (
        <>
          <Popover placement="bottomLeft" content={filterMenu} arrow={false} trigger="click">
            <Button
              className="font-inter font-medium text-sm text-fontGray"
              icon={<PlusOutlined />}
            >
              Add Filter
            </Button>
            
          </Popover>
          {(talentFilterTags.length > 0 || searchText) && (
            <Button
              className="font-inter font-medium text-sm text-black"
              icon={<ReloadOutlined style={{ transform: "scaleX(-1)" }} />}
              onClick={onClearAllFilter}
            >
              Reset
            </Button>
          )}
        </>
      )}

      <Space className="flex flex-wrap mt-2">
        {talentFilterTags.map((tag) => (
          <Tag
            key={tag.uuid}
            bordered={false}
            closable
            onClose={(e) => {
              e.preventDefault();
              removeFilter(tag.uuid);
            }}
          >
            {tag.data}
          </Tag>
        ))}
      </Space>
    </div>
  );
};

const mapStateToProps = (state) => ({
  talentData: state.talent || [],
  eventRoles: state.talent.eventRoles,
  skillCategorized: state.talent.skillCategorized,
  languageCategorized: state.talent.languageCategorized,
});

export default connect(mapStateToProps)(SearchComponent);
